module.exports = __webpack_public_path__ + "img/estacion_b.91728d22.png";